export const darkTheme = {
  // darkMain: "#14171C", // prev 010a16 [old]
  darkMain: "#000813", // prev 010a16 [new]
  bgLiner: "linear-gradient(360deg, rgba(0, 12, 30, 0.97) 0%, #040C17 100%)",
  bgColor1: "#000813",
  bgColor2: "#000C1E",
  bgColor3: "#000F25",
  bgPrimary: "#4D88FF",
  bgPrimaryMedium: "#71A0FF",
  bgPrimaryLight: "#A6C3FF",
  bgSecondary: "#EFAD18",
  bgSecondaryMediEFAD18: "#F2BD49",
  bgSecondaryLight: "#F7D68D",
  bgGreen: "#19D083",
  bgRed: "#FF4D4D",
  bgButton: "#293142",
  bgText: "#D9D9D9",

  white: "#FFFFFF",
  Light1: "#FFFFFF",
  Light2: "#D9DCE3",
  Light3: "#BABCC2",
  Light4: "#A4A6A8",
  Light5: "#35373D",
  // Light6: "#1D2026", // [old]
  Light7: "#293142", // [new]
  Light6: "#000813", // [new]
  // green: "#E8BD71", // [old]
  green: "#4D88FF", // [new]
  green2: "#DBB95515",
  // green3: "#E8BD71", // [old]
  green3: "#4D88FF", // [new]
  darkGreen: "rgba(77, 136, 255, 0.25)",
  // black: "#1D2026", [old]
  black: "#000813", // [new]
  coins: "#71A1E8",
  success: "rgb(17, 184, 124)",
  btnColor: "#D9D9D9",
  blueDark: "#000F25",
  borderColor: "#293142",

  darkBlue: "rgba(0, 100, 250, 0.15)",
  blue: "#71A1E8",
  red: "#F84960",
  lightRed: "rgba(255, 40, 79, 0.1)",
  darkRed: "rgba(255, 40, 79, 0.15)",
  yellow: "#FFC42E",
  btnYellow: "#EFAD1B",
  textColor: "#000000",
  primary: "#77ccdd",
  transparent: "transparent",
  // coin colors
  BTCRight: "rgba(249, 160, 52, 1)",
  BTCLeft: "rgba(249, 160, 52, 0.25)",
  TRXRight: "rgba(239, 0, 39, 1)",
  TRXLeft: "rgba(239, 0, 39, 0.25)",
  ETHRight: "rgba(98, 126, 234, 1)",
  ETHLeft: "rgba(98, 126, 234, 0.25)",
  DOGERight: "rgba(212, 175, 29, 1)",
  DOGELeft: "rgba(212, 175, 29, 0.25)",
  BCHRight: "rgba(141, 195, 81, 1)",
  BCHLeft: "rgba(141, 195, 81, 0.25)",
  USDTRight: "rgba(38, 161, 123, 1)",
  USDTLeft: "rgba(38, 161, 123, 0.25)",
  BNBRight: "rgba(212, 175, 29, 1)",
  BNBLeft: "rgba(212, 175, 29, 0.25)",

  sekeeRight: "#0093ED",
  sekeeLeft: "rgba(158, 108, 75, 0.25)",
  sekebRight: "#9747FF",
  sekebLeft: "rgba(7, 171, 160,0.25)",
  nimRight: "#EFC319",
  nimLeft: "rgba(0, 119, 192, 0.25)",
  robRight: "#E47E25",
  robLeft: "rgba(155, 89, 182, 0.25)",
  geramiRight: "#AD1A8E",
  geramiLeft: "rgba(200, 100, 0, 0.25)",

  gold_bullion_1Right: "#0093ED",
  gold_bullion_1Left: "rgba(158, 108, 75, 0.25)",
  gold_bullion_2Right: "#9747FF",
  gold_bullion_2Left: "rgba(7, 171, 160,0.25)",
  gold_bullion_10Right: "#EFC319",
  gold_bullion_10Left: "rgba(0, 119, 192, 0.25)",
  gold_sut_10Right: "rgba(38, 161, 123, 0.25)",
  gold_sut_10Left: "rgba(155, 89, 182, 0.25)",
  gold_sut_50Right: "#AD1A8E",
  gold_sut_50Left: "rgba(200, 100, 0, 0.25)",
  gold_sut_100Right: "#E47E25",
  gold_sut_100Left: "rgba(200, 100, 0, 0.25)",
  gold_sut_250Right: "#9747FF",
  gold_sut_250Left: "rgba(200, 100, 0, 0.25)",
  gold_sut_500Right: "#EFC319",
  gold_sut_500Left: "rgba(200, 100, 0, 0.25)",

  alwaysWhite: "#FFFFFF",
  //Easy Tether Colors
  etDark9: "#181A1E",
  etDark8: "#242629",
  etDark7: "#14171C",

  // etDark6: "#1D2026", // [old]
  etDark6: "#000813", // [new]
  etDark5: "#35373D",
  etDark4: "#A4A6A8",
  etDark3: "#BABCC2",
  etDark2: "#D9DCE3",
  etDark1: "#3B3C40",
  etRed: "#F84960",
  // etGreen: "#E8BD71", // [old]
  etGreen: "#4D88FF", // [new]
  etGreen2: "#DBB955",
  etBlue: "#71A1E8",
  lendoBlue: "#22326d",
  popupBackground: "#e3e3e3",
};
export const lightTheme = {
  white: "#2C2C2E", // white
  Light2: "#48484A", // LightTow
  Light3: "#8E8E93", // lightFour
  Light4: "#B8B8BF",
  Light5: "#E5E5EA", //darkThree
  Light6: "#FFFFFF",
  darkMain: "#F3F3F3",
  blue: "#71A1E8",
  red: "#F1153D",
  darkGreen: "rgba(232, 189, 113, 0.15)",
  yellow: "#FFC42E",
  darkBlue: "rgba(0, 100, 250, 0.15)",
  green: "#E8BD71",
  green2: "#E8BD71",
  green3: "#E8BD71",
  backgroundColor: "#e0e0e0",
  textColor: "#ffffff",
  primary: "#55aacc",
  black: "#1D2026",
  coins: "#71A1E8",
  success: "rgb(17, 184, 124)",

  // coin colors
  BTCRight: "rgba(249, 160, 52, 1)",
  BTCLeft: "rgba(249, 160, 52, 0.25)",
  TRXRight: "rgba(239, 0, 39, 1)",
  TRXLeft: "rgba(239, 0, 39, 0.25)",
  ETHRight: "rgba(98, 126, 234, 1)",
  ETHLeft: "rgba(98, 126, 234, 0.25)",
  DOGERight: "rgba(212, 175, 29, 1)",
  DOGELeft: "rgba(212, 175, 29, 0.25)",
  BCHRight: "rgba(141, 195, 81, 1)",
  BCHLeft: "rgba(141, 195, 81, 0.25)",
  USDTRight: "rgba(38, 161, 123, 1)",
  USDTLeft: "rgba(38, 161, 123, 0.25)",
  BNBRight: "rgba(212, 175, 29, 1)",
  BNBLeft: "rgba(212, 175, 29, 0.25)",
  alwaysWhite: "#FFFFFF",
  //Easy Tether Colors
  etDark9: "#181A1E",
  etDark8: "#242629",
  etDark7: "#14171C",
  etDark6: "#1D2026",
  etDark5: "#35373D",
  etDark4: "#A4A6A8",
  etDark3: "#BABCC2",
  etDark2: "#D9DCE3",
  etDark1: "#3B3C40",
  etRed: "#F84960",
  etGreen: "#E8BD71",
  etGreen2: "#E8BD71",
  etBlue: "#71A1E8",
  lendoBlue: "#22326d",
};
export const partyTheme = {
  backgroundColor: "#eeff00",
  textColor: "#ff88cc",
  primary: "#aa00ee",
};
